export const CANCEL_ORDER = 'CANCEL_ORDER';
export const EDIT_ORDER = 'EDIT_ORDER';
export const GET_TRANSFER_SCHEDULE_TIMESLOTS = 'GET_TRANSFER_SCHEDULE_TIMESLOTS';
export const ORDER_OPTIONS_FETCH = 'ORDER_OPTIONS_FETCH';
export const TIME_SLOT_DATE_SELECTED = 'TIME_SLOT_DATE_SELECTED';
export const TIME_SLOT_SUBMIT = 'TIME_SLOT_SUBMIT';
export const TIME_SLOT_TIME_SELECTED = 'TIME_SLOT_TIME_SELECTED';
export const RESCHEDULE_MODAL_CLOSED = 'RESCHEDULE_MODAL_CLOSED';

// This Type Gets picked up by Dashboard Reducer
export const ORDER_SUMMARY_FETCH = 'purchase/ORDER_SUMMARY_FETCH';
